<div class='SelectFranchiseeDialog'>
  <div [formGroup]='inputForm' class='SelectFranchiseeDialog__body'>
    <div class='SelectFranchiseeDialog__body__selection'>
      <app-select
        [defaultValue]="user.franchisee_id || ''"
        [items]='getFranchiseeItems()'
        [label]="'Select franchisee'"
        formControlName='franchisee_id'></app-select>
    </div>
    <div class='SelectFranchiseeDialog__body__selection mt-3'>
      <app-select
        [defaultValue]="user.referral_partner_id || ''"
        [disabled]='!inputForm.get("franchisee_id").value || partnersLoading'
        [items]='getReferralPartnerItems()'
        [label]="'Referral partner (optional)'"
        formControlName='referral_partner_id'></app-select>
    </div>
  </div>
</div>
